import { SmartModel, Shark } from "shark-mvc";
import moment from "moment";

class Permission extends SmartModel {
	constructor (data) {
		super();

		this.code = "";
		this.createdAt = "0000-00-00 00:00:00";
		this.createdByGuid = "";
		this.description = "";
		this.guid = "";
		this.name = "";
		this.status = 0;
		this.updatedAt = "0000-00-00 00:00:00";
		this.updatedByGuid = "";

		if (data) {
			this.import(data);
		}
	}

	import (data, options) {
		this.__import(data, options);

		this.createdAt = moment.utc(data.createdAt).local();
		this.status = parseInt(data.status);
		this.updatedAt = moment.utc(data.updatedAt).local();
	}
}

Shark.registerModel("Permission", Permission);

export default Permission;